import React, { useEffect, useState } from 'react';
import { QueryBuilder } from '@mui/icons-material';
import { Input } from 'newComponents/InputSearch/styles';
import { useNotifyAlert } from 'context/NotifyAlert';
import { getTenantId } from 'util/isAdmin';
import SelectSearch from 'newComponents/SelectSearch';
import { useUpdateSettings } from '../hooks/settings';
import { SaveButton } from '../../Departments/NewDepartmentModal/styles';

export const RulesTimeAction = ( { users, settings, isLoading: isLoadingSettings } ) => {
	const tenantId = getTenantId();

	const { updateSettings, isLoading: isUpdatingSettings } = useUpdateSettings();
	const { setShowNotify } = useNotifyAlert();

	const [ selectedOverflowUser, setSelectedOverflowUser ] = useState( '' );
	const [ autoCloseAfterDays, setAutoCloseAfterDays ] = useState( 0 );

	// Initialize form values when settings data is loaded
	useEffect( () => {
		if ( settings ) {
			setSelectedOverflowUser( settings.overflow_to_user_id || '' );
			setAutoCloseAfterDays( settings.auto_close_after_days || 0 );
		}
	}, [ settings ] );

	const handleSaveSettings = async () => {
		try {
			const settingsData = {
				session_id            : `session-${tenantId}`,
				overflow_to_user_id   : selectedOverflowUser,
				auto_close_after_days : autoCloseAfterDays
			};

			await updateSettings( settingsData );
			setShowNotify( { status: 'success', text: 'Configurações salvas com sucesso!' } );
		} catch ( error ) {
			setShowNotify( { status: 'error', text: 'Erro ao salvar configurações.' } );
		}
	};

	return (
		<div style={{ border: '1px solid #e0e0e0', borderRadius: '12px', padding: '22px' }} className='bg-white d-flex flex-column justify-content-between'>
			<div className='d-flex align-items-center' style={{ gap: '10px' }}>
				<QueryBuilder />
				<h3 className='mb-0'>Regras de Tempo e Ação</h3>
			</div>
			<div className='d-flex flex-column' style={{ gap: '16px', marginTop: '16px' }}>
				<div className='d-flex align-items-center' style={{ gap: '12px' }}>
					<span style={{ fontSize: '14px', color: '#0A0A0A' }}>Encerrar casos automaticamente após:</span>
					<Input
						type='number'
						value={autoCloseAfterDays}
						onChange={( e ) => setAutoCloseAfterDays( Number( e.target.value ) )}
						style={{ width: '60px', backgroundColor: '#F3F3F5', borderRadius: '5px', padding: '4px 12px' }}
					/>
					<span style={{ fontSize: '14px', color: '#666' }}>dias sem resposta</span>
				</div>
				<div className='d-flex align-items-center' style={{ gap: '12px' }}>
					<span style={{ fontSize: '14px', color: '#0A0A0A' }}>Transbordar atendimentos para:</span>
					<div style={{ minWidth: '200px' }}>
						{isLoadingSettings ? <span style={{ fontSize: '14px', color: '#666' }}>Carregando...</span> : (
							<SelectSearch
								fullWidth={true}
								options={users.map( user => ( { label: user.email, value: user.acordoFechadoId } ) )}
								value={selectedOverflowUser}
								setSelectedState={setSelectedOverflowUser}
							/>
						)}
					</div>
				</div>
			</div>

			<div className='d-flex justify-content-end' style={{ marginTop: '16px' }}>
				<SaveButton
					onClick={handleSaveSettings}
					disabled={isUpdatingSettings || isLoadingSettings}
					style={{ minWidth: '140px', width: 'auto' }}
				>
					{isUpdatingSettings ? 'Salvando...' : 'Salvar Configurações'}
				</SaveButton>
			</div>
		</div>
	);
};

export default RulesTimeAction;
